export default __webpack_public_path__ + "static/SubpageBanners_Resources-04a97fd9d7c6f0bede002f09a65b959d.jpg";